// activestorage.jsの設定
import * as ActiveStorage from "activestorage";
ActiveStorage.start();

// require("../styles/application/entry.scss")

import Rails from "@rails/ujs";
Rails.start();

// $(document).ready(function () {
//   $(document).on("click", 'a[data-remote="true"]', async (e) => {
//     e.preventDefault();
//     const $this = $(e.currentTarget);

//     try {
//       await $.ajax({
//         url: $this.attr("href"),
//         type: "GET",
//       });
//     } catch (error) {
//       console.error("Ajax request failed:", error);
//       toastr.error("リクエストに失敗しました");
//     }
//   });
// });
